var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.scripts,"loading":_vm.scriptStatus.loading,"items-per-page":50},on:{"click:row":_vm.clickedRow},scopedSlots:_vm._u([{key:"item.type",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"color":"success","outlined":""}},[_vm._v(_vm._s(_vm.getScriptType(item.type)))])]}},{key:"item.interval",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.type == 0 ? item.interval : "N/A")+" ")]}},{key:"item.lastRan",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(_vm.humanDate(item.lastRan)))]}},{key:"item.enabled",fn:function(ref){
var item = ref.item;
return [_vm._v(_vm._s(item.enabled ? _vm.$t("common.yes") : _vm.$t("common.no")))]}},{key:"item.tagDeveui",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.type == 2 ? item.tagDeveui : "N/A")+" ")]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }